// Ítems de navegación por perfil (1=Administrador, 2=Franquiciado, 3=Empleado).
// Fuente única para el drawer (MenuInicial) y la grilla de accesos directos
// del Dashboard — evita mantener dos listas que se puedan desincronizar.
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ErrorIcon from '@mui/icons-material/Error';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SettingsIcon from '@mui/icons-material/Settings';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import IcecreamIcon from '@mui/icons-material/Icecream';
import CategoryIcon from '@mui/icons-material/Category';
import StoreIcon from '@mui/icons-material/Store';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import PunchClockIcon from '@mui/icons-material/PunchClock';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import StorefrontIcon from '@mui/icons-material/Storefront';
import BlockIcon from '@mui/icons-material/Block';

export const MenuItemsConfig = {
  1: [
    { title: "Inicio", icon: <HomeIcon />, route: "/dashboard" },
    { title: "Turnos de caja", icon: <PunchClockIcon />, route: "/turnos" },
    { title: "Registrar", icon: <PointOfSaleIcon />, route: "/registro-producto?mode=create" },
    { title: "Registros de productos", icon: <ReceiptLongIcon />, route: "/registros-productos" },
    { title: "Reporte de anulaciones", icon: <BlockIcon />, route: "/reporte-anulaciones" },
    { title: "Análisis", icon: <InsertChartOutlinedIcon />, route: "/analisis" },
    { title: "Productos", icon: <IcecreamIcon />, route: "/productos" },
    { title: "Actualizar precios", icon: <PriceChangeIcon />, route: "/precios" },
    { title: "Mapeo de precios", icon: <SyncAltIcon />, route: "/mapeo-precios" },
    { title: "Grupos", icon: <CategoryIcon />, route: "/grupos" },
    { title: "Usuarios", icon: <PersonIcon />, route: "/userList" },
    { title: "Sucursales", icon: <StoreIcon />, route: "/sucursales" },
    { title: "Checklist de tareas", icon: <PlaylistAddCheckIcon />, route: "/checklist-tareas" },
    { title: "Grido Competencia", icon: <StorefrontIcon />, route: "/grido-competencia" },
    { title: "Usuarios acciones", icon: <CleaningServicesIcon />, route: "/UsuarioAccionesList" },
    { title: "Auditoría de cambios", icon: <VerifiedUserIcon />, route: "/AuditoriaList" },
    { title: "Errores", icon: <ErrorIcon />, route: "/ErroresList" },
    { title: "Configuración", icon: <SettingsIcon />, route: "/settings" },
  ],
  2: [
    { title: "Inicio", icon: <HomeIcon />, route: "/dashboard" },
    { title: "Turnos de caja", icon: <PunchClockIcon />, route: "/turnos" },
    { title: "Registrar", icon: <PointOfSaleIcon />, route: "/registro-producto?mode=create" },
    { title: "Registros de productos", icon: <ReceiptLongIcon />, route: "/registros-productos" },
    { title: "Reporte de anulaciones", icon: <BlockIcon />, route: "/reporte-anulaciones" },
    { title: "Análisis", icon: <InsertChartOutlinedIcon />, route: "/analisis" },
    { title: "Productos", icon: <IcecreamIcon />, route: "/productos" },
    { title: "Actualizar precios", icon: <PriceChangeIcon />, route: "/precios" },
    { title: "Mapeo de precios", icon: <SyncAltIcon />, route: "/mapeo-precios" },
    { title: "Usuarios", icon: <PersonIcon />, route: "/userList" },
    { title: "Sucursales", icon: <StoreIcon />, route: "/sucursales" },
    { title: "Checklist de tareas", icon: <PlaylistAddCheckIcon />, route: "/checklist-tareas" },
  ],
  3: [
    { title: "Inicio", icon: <HomeIcon />, route: "/dashboard" },
    { title: "Turnos de caja", icon: <PunchClockIcon />, route: "/turnos" },
    { title: "Registrar", icon: <PointOfSaleIcon />, route: "/registro-producto?mode=create" },
    { title: "Registros de productos", icon: <ReceiptLongIcon />, route: "/registros-productos" },
  ],
};

// Menús principales para navegación móvil (bottom nav) — sin cambios, igual para los 3 perfiles.
export const MobileMainMenuConfig = {
  1: [
    { title: "Inicio", icon: <HomeIcon />, route: "/dashboard" },
    { title: "Registrar", icon: <PointOfSaleIcon />, route: "/registro-producto?mode=create" },
    { title: "Más", icon: <MoreVertIcon />, route: "more" },
  ],
  2: [
    { title: "Inicio", icon: <HomeIcon />, route: "/dashboard" },
    { title: "Registrar", icon: <PointOfSaleIcon />, route: "/registro-producto?mode=create" },
    { title: "Más", icon: <MoreVertIcon />, route: "more" },
  ],
  3: [
    { title: "Inicio", icon: <HomeIcon />, route: "/dashboard" },
    { title: "Registrar", icon: <PointOfSaleIcon />, route: "/registro-producto?mode=create" },
    { title: "Más", icon: <MoreVertIcon />, route: "more" },
  ],
};
